import { createSlice } from "@reduxjs/toolkit";
import { createBrowserHistory } from "history";

const history = createBrowserHistory();

export const authSlice = createSlice({
  name: "Auth",
  initialState: {
    users: [],
    currentUser: {},
    selectedPaymentType: "",
    token: "",
    error: {
      value: false,
      message: "",
    },
    info: {
      value: false,
      message: "",
    },
  },
  reducers: {
    loginUser: (state, action) => {
      authSlice.caseReducers.clearalerts(state);
      const { role, data, token } = action.payload;
      const userRole = role || data?.user?.role || data?.author?.role;
      localStorage.setItem("Token", token);
      localStorage.setItem("Role", userRole);
      if (userRole === "customer") {
        history.push("/shop");
        window.location.reload();
      } else if (userRole === "author" && !state.selectedPaymentType) {
        history.push(`/payment-integration`);
        window.location.reload();
      } else {
        history.push(`/dashboard/${userRole}`);
        window.location.reload();
      }
      state.currentUser = data;
      state.token = token;
    },
    logout: (state) => {
      return {
        users: [],
        currentUser: {},
        token: "",
        error: {
          value: false,
          message: "",
        },
        info: {
          value: false,
          message: "",
        },
        selectedPaymentType: "",
      };
    },
    clearalerts: (state) => {
      state.error = { value: false, message: "" };
      state.info = { value: false, message: "" };
    },
    updateCurrentUser: (state, action) => {
      state.currentUser = {
        ...state.currentUser,
        ...action.payload,
      };
    },
    setSelectedPaymentMethod: (state, action) => {
      state.selectedPaymentType = action.payload;
    },
  },
});

export const {
  loginUser,
  clearalerts,
  logout,
  updateCurrentUser,
  setSelectedPaymentMethod,
} = authSlice.actions;
export default authSlice.reducer;
